<template>
	<div class="form">
		<div class="delete" v-if="canDelete" @click="confirm" />

		<b-form-row>
			<b-col cols="12" md="6">
				<input-component
					name="fullName"
					label="Nome completo"
					:required="true"
					v-model="fullName"
					maxlength="255" />
			</b-col>

			<b-col cols="12" md="6">
				<input-component
					name="email"
					label="E-mail"
					:required="true"
					:check="true"
					v-model="email"
					maxlength="255" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="4">
				<input-component
					name="postalCode"
					label="CEP"
					mask="#####-###"
					maxlength="9"
					:required="true"
					:check="true"
					v-model="postalCode"
					@input="getAddress" />
			</b-col>

			<b-col cols="12" md="8">
				<input-component
					name="street"
					label="Endereço"
					:required="true"
					ref="street"
					v-model="street"
					maxlength="255" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="6" md="4">
				<input-component
					name="number"
					label="Número"
					maxlength="6"
					class="mb-0"
					:required="true"
					v-model="number" />
			</b-col>

			<b-col cols="6" md="8">
				<input-component
					name="complement"
					label="Complemento"
					class="mb-0"
					v-model="complement"
					maxlength="150" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="4">
				<input-component
					name="city"
					label="Cidade"
					:required="true"
					ref="city"
					v-model="city"
					maxlength="255" />
			</b-col>

			<b-col cols="12" md="4">
				<input-component
					name="state"
					label="Estado"
					:required="true"
					ref="state"
					v-model="state"
					maxlength="255" />
			</b-col>

			<b-col cols="12" md="4">
				<select-component
					name="country"
					label="País"
					:required="true"
					:options="countries"
					ref="country"
					v-model="country" />
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
import axios from "axios";

import { email, numeric, required } from "vuelidate/lib/validators";
import countries from "@/static/countries";

import InputComponent from "@/components/Form/Inputs/InputComponent";
import SelectComponent from "@/components/Form/Inputs/SelectComponent";

export default {
	name: "ContractFormComponent",
	components: { InputComponent, SelectComponent },
	props: { formKey: Number, canDelete: Boolean, salesforceContactId: String },
	async mounted() {
		if (this.$store.state.form.ownersAndContacts.contract[this.formKey].fullName) {
			this.$v.$touch();
		}

		if (this.$store.state.form.ownersAndContacts.contract[this.formKey].postalCode) {
			await this.getAddress();
		}

		if (this.$refs.country) {
			this.$refs.country.value = "Brasil";
		}
	},
	data: () => ({
		validCep: false,
		type: 0,
	}),
	computed: {
		fullName: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].fullName;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "fullName",
					index: this.formKey,
					value,
				});
			},
		},
		email: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].email;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "email",
					index: this.formKey,
					value,
				});
			},
		},
		postalCode: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].postalCode;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "postalCode",
					index: this.formKey,
					value,
				});
			},
		},
		street: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].street;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "street",
					index: this.formKey,
					value,
				});
			},
		},
		number: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].number;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "number",
					index: this.formKey,
					value,
				});
			},
		},
		complement: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].complement;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "complement",
					index: this.formKey,
					value,
				});
			},
		},
		city: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].city;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "city",
					index: this.formKey,
					value,
				});
			},
		},
		state: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].state;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "state",
					index: this.formKey,
					value,
				});
			},
		},
		country: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract[this.formKey].country;
			},
			set(value) {
				this.$store.commit("setContactData", {
					form: "contract",
					key: "country",
					index: this.formKey,
					value,
				});
			},
		},
		countries() {
			return countries;
		},
	},
	methods: {
		confirm() {
			this.$store.commit("setConfirmForm", {
				form: "contract",
				key: this.formKey,
				salesforceContactId: this.salesforceContactId,
				formKey: this.formKey,
			});

			this.$bvModal.show("modal-confirm");
		},
		async getAddress() {
			const cep = this.postalCode.replace(/\D/g, "");

			if (cep.length !== 8) {
				this.validCep = false;
				return;
			}

			let res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`).catch((err) => {
				console.error(err);

				return {
					status: 502,
					data: {
						erro: true,
					},
				};
			});

			this.validCep = true;

			const addressData = res.data;

			if (!addressData.erro) {
				this.$refs.street.setValue(addressData.logradouro);
				this.$refs.city.setValue(addressData.localidade);
				this.$refs.state.setValue(addressData.uf);
			}
		},
	},
	validations: {
		fullName: {
			required,
		},
		email: {
			required,
			email,
		},
		postalCode: {
			validCep: function () {
				return this.validCep;
			},
			required,
		},
		street: {
			required,
		},
		number: {
			required,
			numeric,
		},
		city: {
			required,
		},
		state: {
			required,
		},
		country: {
			required,
		},
		complement: {},
	},
};
</script>

<style lang="scss">
.form {
	border-radius: 8px;
	border: 1px solid #e7e7e7;
	padding: 40px 40px 15px 40px;
	margin: 20px 0;
	position: relative;
}

.delete {
	content: " ";
	top: -10px;
	right: -10px;
	width: 25px;
	z-index: 99;
	height: 25px;
	position: absolute;
	border-radius: 50%;
	background-color: #ed5417;
	cursor: pointer;
}

.delete::after {
	content: "−";
	color: white;
	position: absolute;
	font-weight: bold;
	margin-left: 0.45rem;
	margin-top: 0.1rem;
}
</style>
